import {AxiosResponse} from "axios"
import {IStandardResponse} from "../types";
import {apiClient, RetryConfig, createRetryingNotificationHandler} from "./apiClient"
import {IUser} from "../types/IUser";
import {IUserDTO} from "../types/dtos/IUserDTO";


export const whoAmI = async (config?: RetryConfig): Promise<IUser> => {
    const url = "/whoami"
    const retryConfig  = config ??  {
            retry: true,
            maxRetries: 100,
            backoff: 300,
            onRetry: createRetryingNotificationHandler({message: "Loading user Failed."})
        } as RetryConfig;
    return apiClient.get(url,retryConfig).then((response: AxiosResponse<IStandardResponse<IUserDTO>>) => {

        return {
            id: response.data.data.id,
            email: response.data.data.email,
            metadata: response.data.data.metadata
        }
    });
}

